import styled, {ThemeProps} from 'styled-components';

import {Theme} from './../../../../theme/types';
import {
  Column,
  Row,
  SectionDefaultStyles,
  ColumnStyles,
  RowW100Styles,
} from './../../common/Layouts/Layouts';

export const ContentWrapperStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  ${ColumnStyles}
  // border: 0.1rem solid ${props.theme.colors.goBrandBlue.light};
  background-color: white;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
`,
);

export const HeadingTextWrapperStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  ${ColumnStyles}
  border-bottom: 0.1rem solid ${props.theme.colors.downriver.light};
  // background-color: white;
  padding: ${props.theme.spacing.xlarge}  ${props.theme.spacing.xxlarge};
`,
);

export const MainContentTextStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  font-size: ${props.theme.font.custom(16)};
  line-height: 1.4;
  background: white;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  >p{
    height: 100%;
  }
`,
);

export const HeadingTextStyle = styled.span(
  (props: ThemeProps<Theme>) => `
  font-size: ${props.theme.font.custom(22)};
  font-family: ${props.theme.font.fontFamily};
  font-weight: bold;
`,
);
